import React, { useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import Cursor from "./Cursor";
import ScrollProgress from "./ScrollProgress";
import PageTransition from "./PageTransition";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="grain" data-testid="page-layout">
      <PageTransition />
      <Cursor />
      <ScrollProgress />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
